/**
 * Registry of product slugs used in URLs: /{slug}/contact-us, etc.
 * Add a new key here when you launch another app section.
 */

const RE_ROOMY_CARDS = [
  {
    emoji: '🛠',
    title: 'Technical Support',
    description:
      'Something not working as expected? App crashes, generation errors, or unexpected behavior — let us know.',
    subject: 'Technical Support',
    cta: 'Get Help',
  },
  {
    emoji: '💳',
    title: 'Billing & Subscriptions',
    description:
      'Questions about your subscription, charges, or renewal? We\'ll do our best to assist or direct you to Apple support.',
    subject: 'Billing Question',
    cta: 'Contact Billing',
  },
  {
    emoji: '🔒',
    title: 'Privacy & Data',
    description:
      'Requests regarding your personal data, privacy rights (GDPR, CCPA), or questions about our privacy practices.',
    subject: 'Privacy Request',
    cta: 'Privacy Request',
  },
  {
    emoji: '💡',
    title: 'Feature Requests',
    description:
      'Have an idea that would make ReRoomy better? We read every suggestion and use them to shape future updates.',
    subject: 'Feature Request',
    cta: 'Share Idea',
  },
];

const SCANNER_CARDS = [
  {
    emoji: '🛠',
    title: 'Technical Support',
    description:
      'Report crashes, bugs, or unexpected behavior — we will look into it.',
    subject: 'Technical Support',
    cta: 'Get Help',
  },
  {
    emoji: '💳',
    title: 'Billing & Subscriptions',
    description:
      'Questions about billing or your plan — contact us and we will help or point you to the right channel.',
    subject: 'Billing Question',
    cta: 'Contact Billing',
  },
  {
    emoji: '🔒',
    title: 'Privacy & Data',
    description:
      'Data access requests, privacy questions, or compliance inquiries.',
    subject: 'Privacy Request',
    cta: 'Privacy Request',
  },
  {
    emoji: '💡',
    title: 'Feature Requests',
    description:
      'Suggestions help us improve the product. Send us your ideas.',
    subject: 'Feature Request',
    cta: 'Share Idea',
  },
];

export const APPS = {
  're-roomy': {
    displayName: 'Re-roomy',
    contact: {
      brandName: 'ReRoomy',
      logoLetter: 'R',
      subtitle: 'ReRoomy · East IT Services s.r.o.',
      tagline:
        "We're here to help. Reach out with any questions, feedback, or support requests.",
      intro:
        "Whether you need help with a subscription, have a question about how ReRoomy works, or want to share feedback — we'd love to hear from you.",
      supportEmail: 'eastappdeveloper@gmail.com',
      applicationLine: 'ReRoomy — AI Room Redesign',
      platform: 'iOS (Apple App Store)',
      cards: RE_ROOMY_CARDS,
      responseNote:
        'We aim to respond to all inquiries within 1–2 business days. For urgent billing issues, please also contact Apple Support directly, as subscription payments are managed through the App Store.',
    },
  },
  scanner: {
    displayName: 'Scanner',
    contact: {
      brandName: 'Scanner',
      logoLetter: 'S',
      subtitle: 'Scanner · East IT Services s.r.o.',
      tagline:
        'Reach out with questions, feedback, or support requests for Scanner.',
      intro:
        'Whether you need technical help, have a product question, or want to share feedback — we are glad to hear from you.',
      supportEmail: 'info@east-it.sk',
      applicationLine: 'Scanner',
      platform: 'Web / mobile (update as needed)',
      cards: SCANNER_CARDS,
      responseNote:
        'We aim to respond to all inquiries within 1–2 business days.',
    },
  },
};

export function isKnownAppSlug(slug) {
  return Boolean(slug && Object.prototype.hasOwnProperty.call(APPS, slug));
}

export function getAppConfig(slug) {
  return APPS[slug] || null;
}
